import cn from 'classnames';
import React from 'react';

interface ShowSelectedHashtagsProps {
  selectedHashtags?: string[];
  hashtagsHandler?: () => void;
  cssClasses: {
    editButtonCss?: string;
    selectedTagsCss: string;
    noSelectedTagsCss: string;
  };
}

export const ShowSelectedHashtags = ({ selectedHashtags, hashtagsHandler, cssClasses }: ShowSelectedHashtagsProps) => (
  <div
    className={cn(cssClasses.selectedTagsCss, {
      [cssClasses.noSelectedTagsCss]: !selectedHashtags?.length
    })}
  >
    {selectedHashtags?.map(selectedHashtag => (
      <span key={selectedHashtag}>#{selectedHashtag}</span>
    ))}
    {hashtagsHandler && <button type="button" className={cssClasses.editButtonCss} onClick={hashtagsHandler} />}
  </div>
);

export default ShowSelectedHashtags;
